<template>
  <div class="user-stats">
    <el-table :data="stats.storage" border>
      <el-table-column :label="quota">
      <el-table-column :label="used">
        <el-table-column prop="name" label="Object Type"></el-table-column>
        <el-table-column prop="available" label="Available"></el-table-column>
        <el-table-column prop="count" label="Used"></el-table-column>
        <el-table-column prop="size" label="Size" :formatter="sizeFormatter"></el-table-column>
      </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import asBytes from '@/components/shared/asBytes'

export default {
  props: ['stats'],
  mixins: [asBytes],
  computed: {
    quota () {
      return 'Available Disk Space: ' + this.asBytes(this.stats.quota)
    },
    used () {
      let total = this.stats.storage.reduce((acc, item) => {
        acc = acc + item.size
        return acc
      }, 0)
      return 'Total Disk Space Used: ' + this.asBytes(total)
    }
  },
  methods: {
    sizeFormatter (row, col) {
      return this.asBytes(row.size)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/users/UserStats.vue